import { DatePicker } from '@mui/x-date-pickers';
import { styled } from '@mui/material';

export const StyledDatePicker = styled(DatePicker)`
    & .MuiOutlinedInput-root {
        border-radius: 8px;
    }
`;
